import { type ReactNode } from 'react';
import { emitInfoToast } from '@adv-frontend/toast';

export const showInfo = (content: ReactNode) =>
    // eslint-disable-next-line no-restricted-syntax -- Только здесь и можно использовать emitInfoToast
    emitInfoToast(content, {
        hasClose: true,
    });
